import { businessKey } from 'queryKeys';

const REG_STATS = 'regStats';

const METRICS = 'metrics';

const MUTATION_EXPORT_CSV = 'exportCSV';
const MUTATION_SEND_TO_EMAIL = 'sendToEmail';

const regStatsQuery = businessKey.query(REG_STATS);

export const grid = regStatsQuery.grid();

export const metrics = regStatsQuery.exact(METRICS);

export const mutations = regStatsQuery.mutations();

export const exportCSVKey = mutations.mutate(MUTATION_EXPORT_CSV);
export const sendToEmailKey = mutations.mutate(MUTATION_SEND_TO_EMAIL);
